module.exports = __webpack_public_path__ + "911b0d04cc84e9ed468a83d6ff9dbfb7.png";